export default __webpack_public_path__ + "static/media/Button-Carousel-Next.2ff21972.svg";